/** @jsxImportSource @emotion/react */
import { useParams } from "react-router-dom";
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { GoBackLinkButton } from "../../components/GoBackLinkButton";
import { routes } from "../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { PreviewReportDataCards } from "./components/PreviewReportDataCards";

export const ReportDetails = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { slug } = useParams<{ slug: string }>();

  return (
    <PageWrapper>
      <GoBackLinkButton
        to={routes.reports(organizationKeyName)}
        text="Back to all reports"
      />
      <PreviewReportDataCards reportApiUrlKey={slug} />
    </PageWrapper>
  );
};
